import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PageHeader from "Component/Headers/pageHeader";
import recruiterBotImage from "Assets/Svg/recruiter-bot.svg";
import recruiterBotBg from "Assets/Svg/recruiter-bot-bg.svg";
import { SwatchesPicker, SketchPicker } from "react-color";
import { CopyToClipboard } from "react-copy-to-clipboard";

import copyIcon from "Assets/newicons/action/copy/outline/copy-outline-16-px.svg";

import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import { getFormattedImageLink } from "Utils";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import "./index.scss";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "Actions/AxiosInstance";
import DynamicForm from "Component/DynamicForm";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import roboposition1 from "Assets/Svg/roboposition1.svg";
import roboposition2 from "Assets/Svg/roboposition2.svg";
import roboposition3 from "Assets/Svg/roboposition3.svg";
import roboposition4 from "Assets/Svg/roboposition4.svg";

const scriptTag = `<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-XXXX');</script>`;

class BotIdentity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ischecked: false,
      copyText: "",
      copied: false,
      animation: false,
      empList: [],
      tagcode: "tagcodegenrated",
      SelectedEmpData: null,
      selectedCompensator: null,
      customtypename: "",
      botname: "",
      tagcode1: "",
      appdata: [{ appid: 1, scripturl: "https", expirydate: null }],
      flag: false,
      imagepath: "",
      customBotImage: false,
      selectedColor: "red",
      displayColorPicker: false,
      generateCodeSnippet: false,
      color: {
        r: "0",
        g: "0",
        b: "0",
        a: "1",
      },
    };
    this.setischecked = this.setischecked.bind(this);
    this.onSave = this.onSave.bind(this);
    this.setCompensator = this.setCompensator.bind(this);
    this.addSource = this.addSource.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.generate = this.generate.bind(this);
    this.copyText = this.copyText.bind(this);
    this.getConsumerApp = this.getConsumerApp.bind(this);
    this.createConsumerApp = this.createConsumerApp.bind(this);
  }

  componentDidMount() {
    // this.getConsumerApp();
  }

  setischecked() {
    this.setState({ ischecked: !this.state.ischecked });
  }

  createConsumerApp() {
    const appdata = this.state;
    const data = {
      appid: appdata.appid,
      scripturl: appdata.scripturl,
      expirydate: appdata.expirydate,
    };
    instance.post(`/subscription/createconsumerapp`, data).then((resp) => {
      this.setState({
        appdata: [],
      });
      console.log("res: ", resp);
    });
  }

  getConsumerApp() {
    // const { employeeid } = this.state;
    instance
      .get(
        `subscription/getconsumerapp/${
          this.state.appid ? this.state.appid : 8
        }`,
      )
      .then((result) => {
        this.setState({
          appdata: result.data.result,
          generateCodeSnippet: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  copyText() {
    // const { data } = this.props;
    const { appdata } = this.state;

    this.setState({
      // copyText: data.emailid,
      copyText: scriptTag,
      copied: true,
      animation: !this.state.animation,
    });
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = (color) => {
    this.setState({ color: color.rgb });
  };

  generate() {
    this.setState({
      generateCodeSnippet: true,
    });
  }

  addSource() {
    this.setState({
      dropdown: true,
      selectedCompensator: null,
      SelectedEmpData: null,
    });
  }

  setCompensator(selectedCompensator) {
    this.setState({
      selectedCompensator,
    });
  }

  handleChange1(key, value) {
    this.setState({ [key]: value });
  }

  handleChangeColor(color) {
    this.setState({ selectedColor: color.hex });
  }

  onSave() {}

  render() {
    return (
      <div className="content-outer-wrapper" style={{ marginBottom: 60 }}>
        <PageHeader header="Bot identity" />
        {this.state.flag ? (
          <Grid container spacing={3}>
            <Grid item xs={12} md={8} sm={12}>
              <p className="normal-dark-secondary margin-bottom-8">
                Give a face to Recruiter Bot
              </p>
              <div className="margin-bottom-24">
                <span className="inline-block margin-right-32">
                  <ProfilePicture
                    src={getFormattedImageLink(this.state.imagepath)}
                    height="80"
                  />
                </span>
                <span>
                  <Button
                    className="btn btn-secondary-md-blue"
                    variant="contained"
                    // onClick={() => this.setState({ flag: true })}
                  >
                    Upload photo
                  </Button>
                </span>
              </div>
              <div style={{ width: 250 }}>
                <DynamicForm
                  fields={textinputconverter({
                    value: this.state.botname,
                    label: "Let’s give your Recruiter Bot a name!",
                    placeholder: "",
                  })}
                  onChange={(e) => this.handleChange1("botname", e)}
                />
              </div>

              <p className="normal-dark-secondary margin-bottom-16">
                Which color theme would you like to follow?
              </p>
              <div>
                <SwatchesPicker
                  colors={[
                    ["#e8b1fe", "#cccccc"],
                    ["#edf5fd", "#fee433"],
                    ["#ffdddd", "#145aa2"],
                    ["#d9ffdf", "#95294d"],
                    ["#07bef8", "#010709"],
                  ]}
                  color={this.state.selectedColor}
                  width="250px"
                  height="100px"
                  overflowY="hidden"
                  className="colorpicker floatleft margin-right-24"
                  onChange={this.handleChangeColor.bind(this)}
                />

                <div className="floatleft">
                  <div
                    style={{
                      padding: "5px",
                      background: "#fff",
                      borderRadius: "1px",
                      boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
                      display: "inline-block",
                      cursor: "pointer",
                    }}
                    onClick={this.handleClick}
                  >
                    <div
                      style={{
                        width: "36px",
                        height: "14px",
                        borderRadius: "2px",
                        background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
                      }}
                    />
                  </div>
                  {this.state.displayColorPicker ? (
                    <div style={{ position: "absolute", zIndex: "2" }}>
                      <div
                        style={{
                          position: "fixed",
                          top: "0px",
                          right: "0px",
                          bottom: "0px",
                          left: "0px",
                        }}
                        onClick={this.handleClose}
                      />
                      <SketchPicker
                        color={this.state.color}
                        onChange={this.handleChange}
                      />
                    </div>
                  ) : null}
                </div>
                <div className="clear-float"></div>
              </div>
              <p className="normal-dark-secondary margin-bottom-16">
                Where on your homepage will recruiter bot stay?
              </p>
              <div className="floatleft margin-right-16 text-center">
                <div className="rounded-rectangle-div">
                  <img src={roboposition1}></img>
                </div>
                <span className="small-dark-secondary margin-top-4">
                  Bottom right
                </span>
              </div>
              <div className="floatleft margin-right-16 text-center">
                <div className="rounded-rectangle-div">
                  <img src={roboposition2}></img>
                </div>
                <span className="small-dark-secondary margin-top-4">
                  Bottom left
                </span>
              </div>
              <div className="floatleft margin-right-16 text-center">
                <div className="rounded-rectangle-div">
                  <img src={roboposition3}></img>
                </div>
                <span className="small-dark-secondary margin-top-4">
                  Middle right
                </span>
              </div>
              <div className="floatleft margin-right-16 text-center">
                <div className="rounded-rectangle-div">
                  <img src={roboposition4}></img>
                </div>
                <span className="small-dark-secondary margin-top-4">
                  Middle left
                </span>
              </div>

              <div className="clear-float"></div>

              <p>To implement Chat Bot on your website generate code snippet</p>

              {/* <Button
                className="btn btn-primary-md-blue"
                variant="contained"
                onClick={this.getConsumerApp}
              >
                Generate code snippet
              </Button> */}

              {this.state.generateCodeSnippet ? (
                <div>
                  <p>
                    Copy the following JavaScript and paste it as close to the
                    opening{" "}
                    <code translate="no" dir="ltr">
                      &lt;head&gt;
                    </code>{" "}
                    tag as possible on every page of your website
                  </p>
                  <div className="code-snippet-outer">
                    <CopyToClipboard text={scriptTag}>
                      <div
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          marginTop: 0,
                        }}
                        onClick={this.copyText}
                        // onClick={this.getConsumerApp}
                        className="emp-mail-icon"
                      >
                        <p
                          className={
                            this.state.animation
                              ? "copied-animation"
                              : "display-none"
                          }
                        >
                          Copied
                        </p>
                        <img src={copyIcon}></img>
                      </div>
                    </CopyToClipboard>

                    {scriptTag}
                    <code>
                      <span className="code-comment">
                        &lt;!-- Code snippet --&gt;
                      </span>
                      <br></br>
                      {this.state.appdata && this.state.appdata.scripturl}
                    </code>
                  </div>
                </div>
              ) : (
                <Button
                  className="btn btn-primary-md-blue"
                  variant="contained"
                  onClick={this.getConsumerApp}
                >
                  Generate code snippet
                </Button>
              )}
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <div
                className="position-rel"
                style={{
                  backgroundImage: `url(${recruiterBotBg})`,
                  backgroundRepeat: "no-repeat",
                  width: 275,
                  height: 201,
                }}
              >
                {this.state.customBotImage ? (
                  <div
                    className="vertical-center"
                    style={{ height: 80, width: 80 }}
                  >
                    <ProfilePicture
                      src={getFormattedImageLink(this.state.imagepath)}
                      height="80"
                    />
                  </div>
                ) : (
                  <div className="vertical-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="275"
                      height="201"
                      viewBox="0 0 275 201"
                      className="width100"
                    >
                      <g
                        fill="none"
                        fillRule="evenodd"
                        transform="translate(-22 -19)"
                      >
                        <rect
                          width="61.72"
                          height="28.624"
                          x="123.409"
                          y="90.113"
                          fill={this.state.selectedColor}
                          fillRule="nonzero"
                          rx="12.97"
                        />
                        <path
                          fill="#000"
                          fillRule="nonzero"
                          d="M128.329 114.343H180.209V115.343H128.329z"
                          opacity=".1"
                        />
                        <path
                          fill="#000"
                          fillRule="nonzero"
                          d="M128.329 94.585H180.209V114.264H128.329z"
                          opacity=".3"
                        />
                        <circle
                          cx="140.404"
                          cy="104.835"
                          r="7.156"
                          fill="#000"
                          fillRule="nonzero"
                          opacity=".1"
                        />
                        <circle
                          cx="168.133"
                          cy="104.835"
                          r="7.156"
                          fill="#000"
                          fillRule="nonzero"
                          opacity=".1"
                        />
                        <path
                          // fill="#1E8CED"
                          fill={this.state.selectedColor}
                          fillRule="nonzero"
                          d="M148.901 118.735H159.63400000000001V124.998H148.901z"
                        />
                        <path
                          fill={this.state.selectedColor}
                          fillRule="nonzero"
                          d="M131.906 123.209H176.63V158.988H131.906zM131.012 166.144H177.525V170.616H131.012zM138.615 181.35L138.615 186.717 138.615 194.768 138.615 199.24 138.615 201.923 146.666 201.923 146.666 199.24 146.666 194.768 146.666 186.717 146.666 181.35 146.666 175.089 138.615 175.089zM162.766 175.089L162.766 181.35 162.766 186.717 162.766 194.768 162.766 199.24 162.766 201.923 170.817 201.923 170.817 199.24 170.817 194.768 170.817 186.717 170.817 181.35 170.817 175.089zM125.815 131.26v8.273a12.101 12.101 0 00-5.947 2.866 14.068 14.068 0 00-3.54 5.191c-1.035 2.507-1.538 5.292-1.744 7.924a45.308 45.308 0 00.495 10.631h-8.944c-.38-4.945-.26-9.187.234-12.83.552-4.107 1.575-7.45 2.87-10.168 2.592-5.436 6.278-8.385 9.516-9.986 3.846-1.902 7.06-1.902 7.06-1.902z"
                        />
                        <path
                          fill="#000"
                          fillRule="nonzero"
                          d="M138.615 175.089H146.66500000000002V181.35H138.615zM138.615 186.717H146.66500000000002V194.76700000000002H138.615zM138.615 199.24H146.66500000000002V201.923H138.615zM162.766 175.089H170.816V181.35H162.766zM162.766 186.717H170.816V194.76700000000002H162.766zM162.766 199.24H170.816V201.923H162.766zM125.815 131.26v8.273a12.101 12.101 0 00-5.947 2.866l-1.113-9.238c3.846-1.902 7.06-1.902 7.06-1.902zM116.328 147.59c-1.035 2.507-1.538 5.292-1.744 7.924l-8.215-2.199c.552-4.107 1.575-7.45 2.87-10.168l7.089 4.443z"
                          opacity=".3"
                        />
                        <path
                          fill={this.state.selectedColor}
                          fillRule="nonzero"
                          d="M182.723 131.26v8.273a12.101 12.101 0 015.946 2.866 14.068 14.068 0 013.54 5.191c1.035 2.507 1.538 5.292 1.744 7.924.253 3.551.087 7.12-.495 10.631h8.945c.38-4.945.258-9.187-.234-12.83-.553-4.107-1.575-7.45-2.871-10.168-2.592-5.436-6.277-8.385-9.516-9.986-3.846-1.902-7.06-1.902-7.06-1.902z"
                        />
                        <path
                          fill="#000"
                          fillRule="nonzero"
                          d="M182.723 131.26v8.273a12.101 12.101 0 015.946 2.866l1.113-9.238c-3.846-1.902-7.06-1.902-7.06-1.902zM192.21 147.59c1.034 2.507 1.537 5.292 1.743 7.924l8.216-2.199c-.553-4.107-1.575-7.45-2.871-10.168l-7.089 4.443z"
                          opacity=".3"
                        />
                        <path
                          fill="#000"
                          fillRule="nonzero"
                          d="M148.901 118.735H159.63400000000001V119.735H148.901zM177.426 129.584v14.98a3.121 3.121 0 01-.832-2.124v-10.735c0-.787.297-1.545.832-2.121zM132.065 130.571v11.214a3.118 3.118 0 01-.833 1.897v-15.008c.486.519.78 1.188.833 1.897zM134.143 158.989H174.394V159.989H134.143zM133.248 170.617H152.926V171.617H133.248zM154.717 170.617H174.395V171.617H154.717z"
                          opacity=".1"
                        />
                        <path
                          fill={this.state.selectedColor}
                          fillRule="nonzero"
                          d="M135.443 63.623H138.52300000000002V90.112H135.443zM170.762 63.623H173.842V90.112H170.762z"
                        />
                        <circle
                          cx="136.881"
                          cy="63.829"
                          r="3.491"
                          fill="#000"
                          fillRule="nonzero"
                          opacity=".1"
                        />
                        <circle
                          cx="136.881"
                          cy="63.623"
                          r="3.491"
                          fill={this.state.selectedColor}
                          fillRule="nonzero"
                        />
                        <circle
                          cx="172.405"
                          cy="63.829"
                          r="3.491"
                          fill="#000"
                          fillRule="nonzero"
                          opacity=".1"
                        />
                        <circle
                          cx="172.405"
                          cy="63.623"
                          r="3.491"
                          fill={this.state.selectedColor}
                          fillRule="nonzero"
                        />
                      </g>
                    </svg>
                  </div>
                )}

                {this.state.botname && (
                  <div className="robotooltip">
                    <p
                      className="normal-dark-secondary ellipsis"
                      style={{ width: 140 }}
                    >{`Hi, I am ${this.state.botname}!`}</p>
                    <div className="tailShadow"></div>
                    <div className="tail2"></div>
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        ) : (
          <div className="position-rel">
            <DefaultComp
              heading="Welcome to your RecruiterBot!"
              subheading="RecruiterBot lives on your website and guides your prospective candidates to apply with ease. Personalize your bot here before it gets to work."
              imageSrc={recruiterBotImage}
            />
            <div className="text-center margin-top-24">
              <Button
                className="btn btn-primary-md-blue"
                variant="contained"
                onClick={() => this.setState({ flag: true })}
              >
                Let’s start!
              </Button>
            </div>
          </div>
        )}
        {this.state.flag && (
          <div
            className="width100"
            style={{
              position: "fixed",
              left: 0,
              background: "white",
              bottom: 0,
              padding: 10,
              borderTop: "1px solid #d4d4d4",
              zIndex: 0,
            }}
          >
            <div>
              <div className="floatright" style={{ marginRight: 72 }}>
                <div>
                  <Button
                    className="btn btn-trans margin-right-16"
                    variant="contained"
                    onClick={this.onCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-primary-md-blue"
                    variant="contained"
                    onClick={this.submit}
                  >
                    Save
                  </Button>
                </div>
              </div>
              <div className="clearfloat"></div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles()(withSnackbar(BotIdentity)));
